var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashCanWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3672 6.33252H3.36719V9.33252C4.47176 9.33252 5.36719 10.228 5.36719 11.3325V15.3325C5.36719 18.1609 5.36719 19.5752 6.24587 20.4538C7.12455 21.3325 8.53876 21.3325 11.3672 21.3325H13.3672C16.1956 21.3325 17.6098 21.3325 18.4885 20.4538C19.3672 19.5752 19.3672 18.1609 19.3672 15.3325V11.3325C19.3672 10.228 20.2626 9.33252 21.3672 9.33252V6.33252ZM10.8672 11.3325C10.8672 10.7802 10.4195 10.3325 9.86719 10.3325C9.3149 10.3325 8.86719 10.7802 8.86719 11.3325V16.3325C8.86719 16.8848 9.3149 17.3325 9.86719 17.3325C10.4195 17.3325 10.8672 16.8848 10.8672 16.3325V11.3325ZM15.8672 11.3325C15.8672 10.7802 15.4195 10.3325 14.8672 10.3325C14.3149 10.3325 13.8672 10.7802 13.8672 11.3325V16.3325C13.8672 16.8848 14.3149 17.3325 14.8672 17.3325C15.4195 17.3325 15.8672 16.8848 15.8672 16.3325V11.3325Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4353 3.70311C10.5493 3.59679 10.8004 3.50285 11.1497 3.43584C11.499 3.36884 11.9269 3.33252 12.3672 3.33252C12.8075 3.33252 13.2354 3.36884 13.5847 3.43584C13.934 3.50285 14.1851 3.59679 14.299 3.70311",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCanWhite);
export default __webpack_public_path__ + "static/media/trashCanWhite.b381569a6b2936fccaf682432a98a8df.svg";
export { ForwardRef as ReactComponent };